module.exports = __webpack_public_path__ + "img/usage.e57c944.png";